import { render, h } from 'preact'
import App from './components/App'

import IntersectionObserver from 'intersection-observer'

document.addEventListener('DOMContentLoaded', () => {
    render(<App site={window.SITE} />, document.querySelector('body'))
})
